import { render, staticRenderFns } from "./DocumentFieldBar.vue?vue&type=template&id=7f2b1704&scoped=true"
import script from "./DocumentFieldBar.vue?vue&type=script&lang=js"
export * from "./DocumentFieldBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2b1704",
  null
  
)

export default component.exports